import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DownloadState {
  Resolution: string;
  Format: number | string; // 0 = preserve original, "jpg" | "png" = selected format
  Quality: number;
  Image: string;
  BatchImages: unknown[];
  Extension: string;
  Create: boolean;
  mainImageWidth: number;
  mainImageHeight: number;
  readyTodownload: boolean;
  templateReady_image: boolean;
  templateReady: boolean;
  Found: boolean;
}

const initialState: DownloadState = {
  /** Empty = maintain original resolution (numeric presets: 1600, 1024, …). */
  Resolution: "",
  Format: 0,
  Quality: 90,
  Image: "",
  BatchImages: [],
  Extension: "",
  Create: false,
  mainImageWidth: 0,
  mainImageHeight: 0,
  readyTodownload: false,
  templateReady_image: false,
  templateReady: false,
  Found: false,
};

export const downloadSlice = createSlice({
  name: "downloadSlice",
  initialState,
  reducers: {
    setResolution: (state, action: PayloadAction<string>) => {
      state.Resolution = action.payload;
    },
    setFormat: (state, action: PayloadAction<number | string>) => {
      state.Format = action.payload;
    },
    setQuality: (state, action: PayloadAction<number>) => {
      state.Quality = action.payload;
    },
    setSettings: (state, action: PayloadAction<{ Quality: number; Format: number; Resolution: string; Found: boolean }>) => {
      state.Quality = action.payload.Quality;
      state.Format = action.payload.Format;
      state.Resolution = action.payload.Resolution;
      state.Found = action.payload.Found;
    },
    setImage: (state, action: PayloadAction<{ img: string; width: number; height: number; readyTodownload: boolean }>) => {
      state.Image = action.payload.img;
      state.mainImageWidth = action.payload.width;
      state.mainImageHeight = action.payload.height;
      state.readyTodownload = action.payload.readyTodownload;
    },
    setCreate: (state, action: PayloadAction<boolean>) => {
      state.Create = action.payload;
    },
    setTemplateReady: (state, action: PayloadAction<boolean>) => {
      state.templateReady = action.payload;
      state.templateReady_image = action.payload;
    },
    setTemplateClearPhase1: (state, action: PayloadAction<boolean>) => {
      state.templateReady_image = action.payload;
    },
    setTemplateClearPhase2: (state, action: PayloadAction<boolean | string>) => {
      state.templateReady = action.payload as boolean;
      state.Image = action.payload as string;
      state.Create = action.payload as boolean;
    },
    setExtension: (state, action: PayloadAction<string>) => {
      state.Extension = action.payload;
    },
    setBatchImages: (state, action: PayloadAction<unknown | null>) => {
      if (!action.payload) state.BatchImages = [];
      else state.BatchImages = [...state.BatchImages, action.payload];
    },
    setClean: (state) => {
      // state.Resolution = "";
      // state.Quality = 50;
      state.Image = "";
      state.Create = false;
      // state.mainImageWidth = 0;
      // state.mainImageHeight = 0;
      state.readyTodownload = false;
    },
    setFound: (state, action: PayloadAction<boolean>) => {
      state.Found = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setResolution,
  setFormat,
  setQuality,
  setSettings,
  setImage,
  setCreate,
  setExtension,
  setClean,
  setTemplateReady,
  setTemplateClearPhase1,
  setTemplateClearPhase2,
  setFound,
  setBatchImages,
} = downloadSlice.actions;

export default downloadSlice.reducer;
